module.exports = __webpack_public_path__ + "nhospitality_icon.svg";